import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import SendIcon from '@material-ui/icons/Send';
import axios from "axios";
import { CKEditor } from "ckeditor4-react";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { notify } from "react-notify-toast";
import { connect } from "react-redux";
import { API } from "../../API";
import Auth from "../../Auth/Auth";
import FormField from "../../Components/FormField/FormField";
import Modal from "../../Components/Modal/Modal";
import Spinner from '../../Components/Spinner/Spinner'
import TeacherPageContainer from "../Container/TeacherPageContainer";
import "../College/Inbox.css"
import { getValidStartDate, handleLogErrorToSlack } from "../../Helper";
import Badge from '@mui/material/Badge';

function InboxCustomer(props) {
  const [filteredBookings, setFilteredBookings] = useState([])
  const [allBookings, setAllBookings] = useState([]);
  const [selectedBooking, setBooking] = useState({})
  const [sendMaterialPopup, setSendMaterialPopup] = useState(false)
  const [event, setEvent] = useState(undefined)
  const [emailContents, setEmailContents] = useState(null)
  const [fileList, setFileList] = useState(null);
  const [subject, setSubject] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [isDisabled, setIsDisabled] = useState(false)
  const [isSendingEmail, setIsSendingEmail] = useState(false)
  const [allInst, setAllInst] = useState([]);
  const fileInputRef = useRef();

  const role = Auth.verifyUserRole();
  const ref = useRef()

  useEffect(() => {
    setIsLoading(false)
    API.allInstUsersForTeacher()
      .then((res) => {
        getAllBookings(res.data);
        getAllInst();
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  const openSendMaterialPopup = (event) => {
    setSendMaterialPopup(true)
    console.log("selectedBooking: ", event)
    if (event) {
      setEvent(event)
    }
  }

  const closeSendMaterialPopup = () => {
    setSendMaterialPopup(false)
    setEvent(null)
    setEmailContents("")
    setFileList(null)
    setSubject("")
  }

  const sendMaterials = () => {
    if (!subject) {
      notify.show("Please enter email subject")
    } else if (!emailContents) {
      notify.show("Please enter email content")
    } /* else if(!files.length) {
      notify.show("Please upload lesson material")
    } */ else {
      console.log("InboxCustomer")
      setIsSendingEmail(true)
      if(!files.length) {
        return API.addMessageToMaterialConversations(
          props.user._id,
          selectedBooking?.materials?.[0]?.sender_id,
          role !== "teacher"
            ? "teacher"
            : selectedBooking?.customer?.role === "customer" ? "customer" : "personnel",
          subject,
          emailContents,
          [],
          selectedBooking?._id,
          selectedBooking?.materials?.[0]?._id
        ).then((res) => {
          setTimeout(() => {
            window.location.reload(false)
          }, 2000)
          setIsSendingEmail(false)
          closeSendMaterialPopup();
          notify.show("Lesson email sent successfully")
        }).catch((err) => {
          setIsSendingEmail(false)
          notify.show(err.response.data.error || "Failed to send email")
          console.log(err.response)
        })
      }

      const zip = require('jszip')();
      for (let file = 0; file < files.length; file++) {
        // Zip file with the file name.
        zip.file(files[file].name, files[file]);
      }
      zip.generateAsync({type: "blob"}).then(zipFiles => {
        // Upload zipped files to AWS
        API.uploadFileToS3({
          fileName: `${subject} ${new Date().getTime()}`,
          fileType: "application/zip",
          _id: "materials",
        })
          .then((res) => {
            const returnData = res.data.data.returnData;

            const signedRequest = returnData.signedRequest;
            const url = returnData.url;
            const options = {
              headers: {
                "Content-Type": "application/zip",
              },
            };
            axios
              .put(signedRequest, zipFiles, options)
              .then((res2) => {
                const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
                const suffix = url.substring(cut_length, url.length);
                // const prefix = "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path=";
                const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
                const new_url = prefix + suffix;

                API.addMessageToMaterialConversations(
                  props.user._id,
                  selectedBooking?.materials?.[0]?.sender_id,
                  role !== "teacher"
                    ? "teacher"
                    : selectedBooking?.customer?.role === "customer" ? "customer" : "personnel",
                  subject,
                  emailContents,
                  fileList ? [new_url] : [],
                  selectedBooking?._id,
                  selectedBooking?.materials?.[0]?._id
                ).then((res) => {
                  setTimeout(() => {
                    window.location.reload(false)
                  }, 2000)
                  setIsSendingEmail(false)
                  closeSendMaterialPopup();
                  notify.show("Lesson email sent successfully")
                }).catch((err) => {
                  setIsSendingEmail(false)
                  notify.show(err.response.data.error || "Failed to send email")
                  console.log(err.response)
                })
              }).catch((error1) => {
              handleLogErrorToSlack(error1, true)
              setIsSendingEmail(false)
              notify.show("Failed to generate material download link")
              console.log(error1);
            });
          })
          .catch((err) => {
            setIsSendingEmail(false)
            console.log(err);
          });
      });
    }
  }

  const getConversationTitle = (job) => {
    const jobInst = allInst.find((inst) => inst._id === job?.campus?.institution_id) || {};
    // console.log(jobInst)
    let title = jobInst?.institution_name + ", " + job.level
    if (job.multiple_date && job.booking_date !== job.end_booking_date) {
      title = title + " from " +  moment(getValidStartDate(job)).format("DD-MM-YYYY")
        + " to " + moment(job.end_booking_date).format("DD-MM-YYYY")
    } else {
      title  = title + " on " + moment(job.booking_date).format("DD-MM-YYYY")
    }
    return title
  }

  const sendMaterialsBySuggestions = () => {
    API.addMessageToMaterialConversations(
      props.user._id,
      selectedBooking?.materials?.[0]?.sender_id,
      role !== "teacher"
        ? "teacher"
        : selectedBooking?.customer?.role === "customer" ? "customer" : "personnel",
      `Materials received by ${props.user.first_name} ${props.user.last_name.slice(0, 1)}`,
      "Received with thanks",
      [],
      selectedBooking?._id,
      selectedBooking?.materials?.[0]?._id
    ).then((res) => {
      setTimeout(() => {
        window.location.reload(false)
      }, 2000)
      closeSendMaterialPopup();
      notify.show("Lesson email sent successfully")
    }).catch((err) => {
      notify.show(err.response.data.error || "Failed to send email")
      console.log(err.response)
    })
  }

  const files = fileList ? [...fileList] : [];

  const uploadFile = (e) => {
    console.log('Files: ', e.target.files)
    setFileList(e.target.files)
  }

  const removeAttachment = (idx) => {
    files.splice(idx, 1)
    setFileList(files)
    fileInputRef.current.value = files;
  }

  const editorToolbar = [
    {
      name: "basicstyles",
      groups: ["basicstyles"],
      items: ["Bold", "Italic", "Strike", "Underline", "-", "Cut", "Copy", "Paste", "Undo", "Redo"],
    },
    {
      name: "paragraph",
      groups: ["list"],
      items: ["NumberedList", "BulletedList"],
    },
    {name: "links", items: ["Link", "Unlink"]},
  ];

  const getAllBookings = (instUsers) => {
    API.getAllBookingsByTeacherID(props.user._id)
      .then((result) => {
        let bookings = []
        let list = result.data
        if (list) {
          list.forEach((booking) => {
            let newMaterial = {...booking};

            booking.materials && booking.materials.forEach((material) => {
              if (material?.receiver_id === props.user._id) {
                newMaterial.customer = instUsers.find((customer) => customer?._id === material?.sender_id);
                newMaterial.is_read = isRead(newMaterial)
                // console.log(newMaterial.customer)
                bookings.push({
                  ...newMaterial,
                  materials: [{...material}]
                });
              }
            })
          })
        }

        bookings.sort((a, b) => (a?.materials?.[0]?.updatedAt < b?.materials?.[0]?.updatedAt) ? 1 : -1)
        if (bookings.length > 0) {
          setBooking(bookings[0])
          markConversationAsRead(bookings[0])
          bookings[0].is_read = true
        }
        setAllBookings(bookings)
        setFilteredBookings(bookings)
        setIsLoading(true)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllInst = () => {
    API.getAllInst()
      .then(function (result) {
        setAllInst(result.data);
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  const isReceiver = (conversation, booking) => {
    let isReceiver = false
    if (booking) {
      console.log(booking.customer?._id, conversation.receiver_id, booking._id)
      if (booking.customer?._id === conversation.receiver_id) {
        isReceiver = true
      }
    } else {
      if (selectedBooking.customer?._id === conversation.receiver_id) {
        isReceiver = true
      }
    }
    return isReceiver
  }

  const markConversationAsRead = (booking) => {
    API.markAConversationAsRead(booking?.materials?.[0]?._id)
      .then()
      .catch(err => {
        console.log(err.response)
      })
    if (filteredBookings.length > 0) {
      let newBookings = filteredBookings.map(b => {
        let updatedBooking = b;
        if (b._id === booking._id) {
          updatedBooking.is_read = true
        }
        return updatedBooking
      })
      // console.log(newBookings)
      setFilteredBookings(newBookings)
    }
  }

  const getSenderName = (booking) => {
    if (booking?.customer?.role === "customer") {
      return booking?.customer?.first_name + " " + booking?.customer?.last_name
    } else {
      return booking?.customer?.personnel_first_name + " " + booking?.customer?.personnel_last_name
    }
  }

  const search = (e) => {
    const keyword = e.target.value.toLowerCase();
    let filteredBookings = allBookings.filter(booking => {
      const title = getConversationTitle(booking)?.toLowerCase();
      return title.includes(keyword)
    })
    setFilteredBookings(filteredBookings)
  }

  const isRead = (booking) => {
    let isRead = booking?.materials?.[0]?.is_read || false
    // console.log(booking)
    const conversations = booking?.materials?.[0]?.conversations || []
    conversations.forEach(c => {
      if (!isReceiver(c, booking) && !c.is_read) {
        isRead = false;
      }
    })
    return isRead
  }

  useEffect(() => {
    if (ref) {
      ref.current.scrollIntoView();
    }
  }, [ref, selectedBooking])

  return (
    <TeacherPageContainer
      header={props.user.preferred_name}
      tabs={null}
    >
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h5" className="header-message">Chat</Typography>
          </Grid>
        </Grid>
        <Grid container component={Paper} className="chat-section w-100">
          <Grid item xs={4} className="h-100 user-tabs-border">
            <Grid item xs={12} className="search-conversation">
              <TextField
                id="outlined-basic-email"
                label="Search"
                variant="outlined"
                onChange={search}
                fullWidth
              />
            </Grid>
            <Divider/>
            <List className="tab-user">
              {isLoading ?
                (filteredBookings && JSON.stringify(filteredBookings) !== "[]" ?
                  filteredBookings.map(booking => (
                    <ListItem
                      button
                      key={booking?._id}
                      selected={booking?.materials?.[0]?._id === selectedBooking?.materials?.[0]?._id}
                      className="conversation-tab"
                      onClick={() => {
                        setBooking(booking)
                        markConversationAsRead(booking)
                      }}>
                      <ListItemIcon>
                        <Badge
                          color="primary"
                          variant={booking.is_read ? "" : "dot"}
                        >
                          <Avatar
                            className="inbox-college-logo"
                            variant="square"
                            src={allInst.find((inst) => inst._id === booking?.campus?.institution_id)?.logo}/>
                        </Badge>
                      </ListItemIcon>
                      <div className="d-flex flex-column justify-content-start">
                        <ListItemText
                          primary={getConversationTitle(booking)}
                        />
                        {booking?.materials?.[0]?.updatedAt && <ListItemText
                          secondary={`Updated: ${moment(booking?.materials?.[0]?.updatedAt)
                            .format('DD-MM-YYYY, h:mm a')}`}/>}
                      </div>
                    </ListItem>
                  ))
                  : <ListItem>No messages to display</ListItem>)
                : <Spinner small/>}
            </List>
          </Grid>
          <Grid item xs={8} className="h-100">
            <List className="message-area">
              {selectedBooking?.materials?.[0] && <ListItem>
                <Grid container direction="column" alignItems="flex-start">
                  <Grid
                    xs={11}
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    className="message-sender"
                  >
                    <ListItemText primary={
                      <span
                        className="font-weight-bold"
                        dangerouslySetInnerHTML={{
                          __html: selectedBooking?.materials?.[0]?.subject?.replace('[No-reply]', '')
                        }}
                      />
                    }/>
                    <ListItemText primary={
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                          selectedBooking?.materials?.[0]?.content
                        }}
                      />
                    }/>
                    {selectedBooking?.materials?.[0]?.attachments?.[0] && <ListItemText primary={
                      <a
                        href={selectedBooking?.materials?.[0]?.attachments?.[0]}
                        style={{ color: "blue" }}
                      >Attached files
                      </a>}
                    />}
                  </Grid>
                  <Grid item>
                    <div className="conversation-time">
                      {moment(selectedBooking?.materials?.[0]?.createdAt).format('MMMM Do YYYY, h:mm a')}</div>
                  </Grid>
                </Grid>
              </ListItem>}
              {selectedBooking?.materials && selectedBooking?.materials?.[0]?.conversations?.map((conversation) => (
                <ListItem key={conversation._id}>
                  <Grid container direction="column" alignItems={isReceiver(conversation) ? "flex-end" : "flex-start"}>
                    <Grid
                      xs={11}
                      container
                      direction="column"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      className={isReceiver(conversation) ? "message-receiver" : "message-sender"}
                    >
                      <ListItemText primary={
                        <span
                          className="font-weight-bold"
                          dangerouslySetInnerHTML={{
                            __html:
                            conversation?.subject?.replace('[No-reply]', '')
                          }}
                        />
                      }/>
                      <ListItemText primary={
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                            conversation?.content
                          }}
                        />
                      }/>
                      {conversation?.attachments?.[0] && <ListItemText primary={
                        <a
                          href={conversation.attachments[0]}
                          style={{ color: "blue" }}
                        >Attached files
                        </a>}
                      />}
                    </Grid>
                    <Grid item>
                      <div className="conversation-time">
                        {moment(conversation?.updatedAt).format('MMMM Do YYYY, h:mm a')}</div>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
              <div ref={ref}/>
            </List>
            {JSON.stringify(selectedBooking) !== "{}" && (
              <>
                <Divider/>
                <Grid container className="send-field pr-2">
                  <div className="d-flex">
                    <ListItemText
                      className="message-suggestions"
                      onClick={sendMaterialsBySuggestions}
                    >
                      Received with thanks
                    </ListItemText>
                    <ListItemText
                      className="message-suggestions"
                      onClick={() => {
                        setSubject(`Question re lesson materials from ${props.user.first_name} ${props.user.last_name.slice(0, 1)}`)
                        setIsDisabled(true)
                        openSendMaterialPopup(selectedBooking)
                      }}>
                      May I ask a question?
                    </ListItemText>
                  </div>
                  <Grid>
                    <Fab
                      className="send-email-icon"
                      size="medium"
                      aria-label="add"
                      onClick={() => {
                        setIsDisabled(false)
                        openSendMaterialPopup(selectedBooking)
                      }}
                    >
                      <SendIcon fontSize="small"/>
                    </Fab>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </div>

      <Modal
        className="w-50"
        header={event
          ? "Send Email to " +
          `${selectedBooking?.customer?.role === "customer" 
            ? selectedBooking?.customer?.first_name : selectedBooking?.customer?.personnel_first_name} 
          ${selectedBooking?.customer?.role === "customer"
            ? selectedBooking?.customer?.last_name?.slice(0, 1)
            : selectedBooking?.customer?.personnel_last_name?.slice(0, 1) }`
          : "Send Email"}
        onClose={closeSendMaterialPopup}
        show={sendMaterialPopup}
        enforceFocus={false}
      >
        <FormField
          label="Subject"
          id="email-subject"
          type="text"
          onChange={(e) => setSubject(e.target.value)}
          value={subject}
          disabled={isDisabled}
          required
        >
        </FormField>
        <label>Email Contents</label>
        <CKEditor
          config={{ toolbar: editorToolbar, removeButtons: 'Subscript, Superscript', versionCheck: false }}
          onChange={({editor}) => setEmailContents(editor.getData())}
          content={emailContents}
          style={{ boxShadow: "inset 0 0 0 1px #fff, 1px 1px 2px #1beabd, 1px 1px 8px #10afff" }}
        />
        <div className="form-row py-3">
          <div className="col-sm-auto py-2">
            <button
              type="submit"
              className="btn btn-outline-secondary btn-block"
              onClick={() => document.getElementById("attachments").click()}
              disabled={fileList && fileList?.length > 0}
            >
              Attachments
              <i className="align-middle icon-paper-clip fa fa-paperclip ml-1"/>
              <input
                id="attachments"
                type="file"
                onChange={(e) => uploadFile(e)}
                multiple
                className="d-none"
                ref={fileInputRef}
              />
            </button>
            <ul>
              {files.map((file, i) => (
                <div key={i}>
                  <li className="d-inline" key={i}>{file.name}</li>
                  <i
                    className="mdi mdi-delete-circle mt-1 ml-1 uploaded-file-delete-icon"
                    onClick={() => removeAttachment(i)}
                  />
                </div>
              ))}
            </ul>
          </div>
          <div className="col py-2">
            <button
              className="btn btn-primary float-right ml-1"
              onClick={sendMaterials}
              disabled={isSendingEmail}
            >
              Send Email
            </button>
            <div className={isSendingEmail ? "text-right text-secondary pt-1 mr-2" : "d-none"}>Sending...</div>
          </div>
        </div>
      </Modal>

    </TeacherPageContainer>
  );
}

const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(InboxCustomer);
